// @flow
import * as React from 'react';
import type { ClipConfig } from '../hoc/Clip';

import './ClippingToolbar.css';

type Props = {
  clipConfig: ClipConfig,
  duration: number,
  width: number
};

class ClippingToolbar extends React.Component<Props, {}> {
  getScale = () => {
    const { duration, width } = this.props;
    return width / duration;
  };

  render() {
    const { clipConfig, width } = this.props;
    const scale = this.getScale();
    const startX = clipConfig.clipStart * scale;
    const endX = clipConfig.clipEnd * scale;

    return (
      <div name="ClippingToolbar">
        {clipConfig.renderClipBody(scale, <div className="bar" style={{ width: endX - startX }} />)}
        {clipConfig.renderClipStart(scale, <div className="left" />)}
        {clipConfig.renderClipEnd(width, scale, <div className="right" />)}
      </div>
    );
  }
}

export default ClippingToolbar;
